import { company } from "../mock/mock";
import { Phone, MapPin, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1F1914] text-white/70">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <span className="font-serif text-2xl text-white">
            Go<span className="text-[#A17E4A]">Drapery</span>
          </span>
          <p className="mt-4 leading-relaxed text-white/60">
            Custom window coverings crafted with quality and care in Richmond Hill, ON.
          </p>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4">Explore</h4>
          <ul className="space-y-2.5">
            <li><a href="/#services" className="hover:text-[#E7CFA6] transition-colors">Services</a></li>
            <li><a href="/#gallery" className="hover:text-[#E7CFA6] transition-colors">Gallery</a></li>
            <li><Link to="/visualizer" className="hover:text-[#E7CFA6] transition-colors">Drape Visualizer</Link></li>
            <li><a href="/#reviews" className="hover:text-[#E7CFA6] transition-colors">Reviews</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4">Contact</h4>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-[#A17E4A] mt-1" />
              <a href={company.phoneHref} className="hover:text-[#E7CFA6]">{company.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#A17E4A] mt-1" />
              <span>{company.email}</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#A17E4A] mt-1" />
              <span>{company.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4">Hours</h4>
          <p className="flex items-start gap-3">
            <Clock className="w-4 h-4 text-[#A17E4A] mt-1" />
            <span>{company.hours}<br />Sunday: Closed</span>
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 text-sm text-white/45 flex flex-col md:flex-row justify-between gap-3 items-center">
          <span>© {new Date().getFullYear()} {company.name}. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>Richmond Hill, Ontario • Custom Window Coverings</span>
            <Link to="/admin" className="text-white/35 hover:text-[#E7CFA6] transition-colors">Manage Gallery</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
